<!-- @migration task: review uses of `navigating` -->
<script lang="ts">
	import Accordion from '$lib/accordion/accordion.svelte';
	import { goto } from '$app/navigation';
	import TabController from '$lib/tabController/tabController.svelte';
	import type { AccordionTheme, AccordionItem, AccordionCategory } from './types';
	import FAQHelp from '$lib/faq/help.svelte';
	import CustomParagraph from '$lib/customParagraph/customParagraph.svelte';
	import type { InputValue } from '@portabletext/svelte';

	interface Props {
		selectedTab?: string | null;
		categories: AccordionCategory[];
		items: AccordionItem<InputValue>[];
		border?: boolean;
		theme?: AccordionTheme;
		supportLink: { title: string; link: string };
	}

	let {
		selectedTab = null,
		categories,
		items,
		border = true,
		theme = 'brown',
		supportLink
	}: Props = $props();
</script>

<div class="flex max-md:flex-col max-md:gap-y-8 md:gap-x-16 lg:gap-x-32 2xl:gap-x-48">
	<TabController
		class="flex-row max-md:-mx-4 max-md:overflow-x-scroll max-md:px-4 md:flex-col lg:mt-4"
		tabs={categories}
		{selectedTab}
		onselect={(slug) => {
			selectedTab = slug;
			goto(`/faq${slug ? '/' + slug : ''}`);
		}}
	>
		<!-- Support link on > md -->
		{#snippet helpDesktop()}
			<div class="mt-8">
				<FAQHelp linkTitle={supportLink.link} headline={supportLink.title} />
			</div>
		{/snippet}
	</TabController>

	<div class="flex-1">
		{#each items as item, i}
			<Accordion title={item.title} border={i < items.length - 1 ? border : false} {theme}>
				<div class="pb-6 text-[18px] leading-[25.2px] text-brown-1">
					<CustomParagraph content={item.text} />
				</div>
			</Accordion>
		{/each}
	</div>
</div>

<!-- Support link on <md -->
<div class="my-8 md:hidden">
	<FAQHelp class="text-[20px]" linkTitle={supportLink.link} headline={supportLink.title} />
</div>
